import service from '@/middleware'

const stateApi = {
    /**
     * Para cargar los selectores de estados en el ABM de Empresas
     */
    async findAllForSelector(enterpriseId) {
        let response
        if (enterpriseId) {
            response = await service.http.get(`/api/states/all-for-selector`, { params: { enterpriseId } })
        } else {
            response = await service.http.get(`/api/states/all-for-selector`)
        }
        return response
    },
    /**
     * Datos para la tabla del ABM de tipos de estados
     * @param {*} pageSize
     * @param {*} pageNumber
     */
    async findAllStateType(pageSize, pageNumber) {
        const url = pageSize != null && pageNumber != null
            ? `/api/states/type/abm-all?pageSize=${pageSize}&pageNumber=${pageNumber}`
            : `/api/states/type/abm-all`
        const response = await service.http.get(url)
        return response
    },
    /**
     * Total de tipos de estados para el paginador de la tabla del ABM
     */
    async getStateTypeTotal () {
        const result = await service.http.get(`/api/states/type/total`)
        return result
    },
    /**
     * Para obtener un tipo de estado con el id enviado como param
     * @param {*} stateTypeId
     */
    async findOneStateType (stateTypeId) {
        const result = await service.http.get(`/api/states/type/one-by-id/${stateTypeId}`)
        return result
    },
    /**
     * Para crear un nuevo tipo de estado
     * @param {*} stateTypeDto
     */
    async createStateType (stateTypeDto) {
        const result = await service.http.post(`/api/states/type/create`, stateTypeDto)
        return result
    },
    /**
     * Para actualizar un tipo de estado
     * @param {*} stateTypeDto
     */
    async updateStateType (stateTypeDto) {
        const result = await service.http.put(`/api/states/type/update`, stateTypeDto)
        return result
    },
    /**
     * Para eliminar un tipo de estado
     * @param {*} id
     */
    async deleteOneStateType (id) {
        const result = await service.http.delete(`/api/states/type/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteManyStateType (ids) {
        const result = await service.http.put(`/api/states/type/multiple-delete`, ids)
        return result
    },
    /**
     * Validación de una traducción del nombre
     * @param {*} locale
     * @param {*} translation
     */
    async validateTranslation (locale, translation, id) {
        let result
        if (id) {
            result = await service.http.get(`/api/states/type/validate-translation?locale=${locale}&translation=${translation}&id=${id}`)
        } else {
            result = await service.http.get(`/api/states/type/validate-translation?locale=${locale}&translation=${translation}`)
        }
        return result
    },

    async getTypesByKeys(keys) {
        const result = await service.http.post(`/api/states/types-by-keys`, keys)
        return result
    },

   
}

export default stateApi
